import { useState, type FormEvent } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { Alert, AuthCard, Button, Field } from '../components/ui'
import { useSetupPassword } from '../lib/session'
import { passwordHint } from './RegisterPage'

export default function PasswordSetupPage() {
  const navigate = useNavigate()
  const setup = useSetupPassword()
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const mismatch = confirmation.length > 0 && password !== confirmation

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (password !== confirmation) {
      return
    }

    setup.mutate(
      { password, confirmation },
      {
        onSuccess: (response) =>
          void navigate({ to: response.next === 'mfa' ? '/mfa' : '/' }),
      },
    )
  }

  return (
    <AuthCard
      title="Choisissez votre mot de passe"
      subtitle="C'est votre premiere connexion : definissez le mot de passe de ce compte."
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Field
          label="Nouveau mot de passe"
          type="password"
          name="password"
          autoComplete="new-password"
          required
          minLength={12}
          hint={passwordHint}
          autoFocus
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <Field
          label="Confirmation du mot de passe"
          type="password"
          name="confirmation"
          autoComplete="new-password"
          required
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
        />

        {mismatch && <Alert>Les deux mots de passe sont differents.</Alert>}
        {setup.isError && <Alert>{setup.error.message}</Alert>}

        <Button type="submit" disabled={setup.isPending || mismatch}>
          {setup.isPending ? 'Enregistrement...' : 'Enregistrer et me connecter'}
        </Button>
      </form>
    </AuthCard>
  )
}
